<template>
  <div class="wheel_wrap">

    <Wheel
      ref="wheel"
      :gift="gift"
      :data="data"
      @done="done"
      :imgParams="logo"
      @click="spinTheWheel"
    />
  </div>
</template>

<script>
import { Wheel } from "vue3-fortune-wheel";
import axios from "axios";
import {useToast} from "vue-toastification";
// import 'vue3-fortune-wheel/dist/library.css'

export default {
  name: "CashBack",
  components: {
    Wheel,
  },
  data() {
    return {
      gift: Math.floor((Math.random() * 6) + 1),
      logo: {
        width: 130,
        height: 156,
        src:
          "https://iswitch.calsob.com//storage/uploads/1665659529_Cashback.png",
      },
      data: [
        {
          id: 1,
          value: "Rs 5",
          bgColor: "#7d7db3",
          color: "#ffffff",
        },
        {
          id: 2,
          value: "Rs 10",
          bgColor: "#ffffff",
          color: "#000000",
        },
        {
          id: 3,
          value: "Rs 15",
          bgColor: "#c92729",
          color: "#ffffff",
        },
        {
          id: 4,
          value: "Rs 20",
          bgColor: "#7d7db3",
          color: "#ffffff",
        },
        {
          id: 5,
          value: "Rs 25",
          bgColor: "#ffffff",
          color: "#000000",
        },
        {
          id: 6,
          value: "Rs 30",
          bgColor: "#c92729",
          color: "#ffffff",
        },
      ],
    };
  },
  methods: {
    async saveDataToDB(postData = null) {
      const token = "Rf4PXxljeKXjex98XhyTxK8tILXocSdmrr32xn2s"
      const config = {
          headers: { Authorization: `Bearer ${token}` }
      };
      return new Promise((resolve, reject) => {
        axios
          .post(process.env.VUE_APP_API_URL + "/api/cashbacks", postData,config)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async done(params) {
      const code = this.$route.params.id
      console.log(params);
      const postData = {
         cashback: params.id * 5,
         code: code
      };
      try {
        let {data} = await this.saveDataToDB(postData);
        console.log(data.payload);
      } catch (error) {
        console.log(error);
      }
    },
    spinTheWheel() {
      this.$refs.wheel.spin();
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.wheel_wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
